import React, { Fragment } from 'react';
import 'moment/locale/es';

import withGlobalData from 'components/providers/global-data';

import { PublicRoutes, PrivateRoutes } from './routes';

const App = ({ token }) => <Fragment>{token ? <PrivateRoutes /> : <PublicRoutes />}</Fragment>;

export default withGlobalData(App);
